// Comportamentos globais: anúncio, cabeçalho, drawers, slideshow, abas e carrosséis.
const $$ = (s, r = document) => [...r.querySelectorAll(s)];

// Formata centavos pelo formato de moeda da loja; trim tira ",00" como o money_without_trailing_zeros
window.theme.money = (cents, trim) => window.theme.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
  const noDec = k.includes('no_decimals');
  const [int, dec] = (cents / 100).toFixed(noDec ? 0 : 2).split('.');
  const [th, dp] = k.includes('comma') ? ['.', ','] : k.includes('apostrophe') ? ["'", '.'] : [',', '.'];
  const whole = int.replace(/\B(?=(\d{3})+$)/g, th);
  return noDec || (trim && dec === '00') ? whole : whole + dp + dec;
});
const lazy = (url) => import(url);

function open(id) {
  const d = document.getElementById(id);
  if (!d || d.open) return;
  d.showModal();
  document.documentElement.style.overflow = 'hidden';
  if (id === 'search-drawer') {
    d.querySelector('input[type=search]')?.focus();
    lazy(window.theme.assets.search);
  }
  if (id === 'cart-drawer') lazy(window.theme.assets.cart);
}
function close(d) {
  d.close();
  document.documentElement.style.overflow = '';
}
// Em tela de toque, o primeiro toque em item com submenu abre o submenu
const touch = matchMedia('(hover:none)');
document.addEventListener('click', (e) => {
  const t = e.target;
  const sub = t.closest?.('.nav__item.has-sub > .nav__link');
  if (sub && touch.matches && !sub.parentElement.classList.contains('is-open')) {
    e.preventDefault();
    $$('.nav__item.is-open').forEach((n) => n.classList.remove('is-open'));
    sub.parentElement.classList.add('is-open');
    return;
  }
  if (touch.matches && !t.closest?.('.nav__item')) $$('.nav__item.is-open').forEach((n) => n.classList.remove('is-open'));
  const o = t.closest('[data-open]');
  if (o) { e.preventDefault(); return open(o.dataset.open); }
  const x = t.closest('[data-close]');
  if (x) return close(x.closest('dialog'));
  if (t.nodeName === 'DIALOG') close(t); // clique no backdrop
});
// Em campo de busca, o Esc do navegador só apaga o texto; aqui ele fecha o painel de uma vez
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && e.target.matches?.('dialog[open] input[type=search]')) { e.preventDefault(); close(e.target.closest('dialog')); }
});
document.addEventListener('close', () => { if (!document.querySelector('dialog[open]')) document.documentElement.style.overflow = ''; }, true);

// Cabeçalho transparente só no topo da home
const hdr = document.querySelector('[data-hdr]');
if (hdr && document.body.classList.contains('has-overlay-header')) {
  const hero = document.querySelector('.hero--overlay');
  if (hero) {
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:40px;width:1px;pointer-events:none';
    document.body.prepend(sentinel);
    new IntersectionObserver(([e]) => hdr.classList.toggle('is-solid', !e.isIntersecting)).observe(sentinel);
  } else hdr.classList.add('is-solid');
}

function rotator(items, onChange, ms) {
  let i = 0, timer;
  const go = (n) => { i = (n + items.length) % items.length; onChange(i); };
  const reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  const stop = () => clearInterval(timer);
  const play = () => { stop(); if (ms && !reduce && items.length > 1) timer = setInterval(() => go(i + 1), ms); };
  play();
  return { go: (n) => { go(n); play(); }, next: () => { go(i + 1); play(); }, prev: () => { go(i - 1); play(); }, stop, play };
}

function initAnn(el) {
  const ms = $$('.ann__msg', el);
  const r = rotator(ms, (i) => ms.forEach((m, k) => m.classList.toggle('is-on', k === i)), 5000);
  el._stop = r.stop;
  el.querySelector('[data-ann-prev]')?.addEventListener('click', r.prev);
  el.querySelector('[data-ann-next]')?.addEventListener('click', r.next);
}

// Valores medidos na referência
const REDUCE = matchMedia('(prefers-reduced-motion:reduce)').matches;
const UP = [{ transform: 'translateY(100%)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }];
const anim = (e, kf, o) => (REDUCE || !e ? null : e.animate(kf, o));
// Cortina da direita: a moldura entra e o conteúdo faz o movimento inverso, então a imagem fica parada.
// Sem clip-path: a animação dele derrubava a página em alguns navegadores (ver docs/auditoria).
const wipe = (frame, inner, duration) => {
  const o = { duration, easing: 'cubic-bezier(1,0,0,1)' };
  anim(frame, [{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }], o);
  inner.forEach((n) => anim(n, [{ transform: 'translateX(-100%)' }, { transform: 'translateX(0)' }], o));
};

function staggerIn(items) {
  let delay = 0, step = 97;
  items.forEach((it) => {
    it.classList.remove('r-wait');
    anim(it, [{ transform: 'translateY(60px)', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 600, delay, easing: 'ease', fill: 'backwards' });
    delay += step;
    step = Math.max(step - 6, 30);
  });
}

function initSlideshow(el) {
  const slides = $$('[data-slide]', el), bars = $$('.hero__bar', el);
  let cur = 0;
  const arm = (s) => s?.classList.add('is-armed');
  const go = (n) => {
    const i = (n + slides.length) % slides.length;
    if (i === cur) return;
    const out = slides[cur], inn = slides[i];
    arm(out);
    arm(inn);
    arm(slides[(i + 1) % slides.length]);
    out.classList.remove('is-on');
    inn.classList.add('is-on');
    bars.forEach((b, k) => b.classList.toggle('is-on', k === i));
    anim(out, [{ visibility: 'visible' }, { visibility: 'hidden' }], { duration: 500 });
    wipe(inn, [...inn.children], 500);
    [...inn.querySelector('.hero__txt')?.children || []].forEach((c, k) => {
      anim(c, UP, { duration: 450, delay: 100 + k * 100, easing: 'cubic-bezier(.5,.06,.01,.99)', fill: 'backwards' });
    });
    cur = i;
  };
  addEventListener('load', () => setTimeout(() => arm(slides[1]), 1500), { once: true });
  bars.forEach((b, k) => b.addEventListener('click', () => go(k)));
  if (el.classList.contains('hero--auto')) el.addEventListener('animationend', (e) => { if (e.animationName === 'heroBar') go(cur + 1); });
}

// Primeira medição só depois do navegador montar a página, sem forçar layout no carregamento
const afterLayout = (el, fn) => new IntersectionObserver((_, io) => { io.disconnect(); fn(); }).observe(el);

function initTabs(el) {
  if (el.classList.contains('iwt')) return initIwt(el);
  const tabs = $$('[role=tab]', el);
  const nav = tabs[0]?.parentElement;
  if (!nav) return;
  const pos = document.createElement('span');
  pos.className = 'tabsnav__pos';
  nav.append(pos);
  nav.classList.add('has-pos');
  const place = (b) => {
    if (!nav.offsetWidth) return;
    const w = nav.scrollWidth;
    pos.style.width = w + 'px';
    pos.style.scale = `${b.offsetWidth / w} 1`;
    pos.style.translate = `${b.offsetLeft}px`;
  };
  const panel = (t) => document.getElementById(t.getAttribute('aria-controls'));
  const show = (p, on) => { if (p.tagName === 'DETAILS') p.open = on; else p.hidden = !on; };
  let cur = Math.max(tabs.findIndex((t) => t.classList.contains('is-on')), 0);
  afterLayout(nav, () => place(tabs[cur]));
  new ResizeObserver(() => place(tabs[cur])).observe(nav);
  tabs.forEach((t, i) => t.addEventListener('click', async () => {
    if (i === cur) return;
    const old = panel(tabs[cur]), next = panel(t);
    tabs.forEach((o, k) => { o.classList.toggle('is-on', k === i); o.setAttribute('aria-selected', k === i); });
    place(t);
    cur = i;
    await anim(old, [{ opacity: 1 }, { opacity: 0 }], { duration: 250, easing: 'ease' })?.finished;
    tabs.forEach((o, k) => { if (k !== cur) show(panel(o), false); });
    show(panel(tabs[cur]), true);
    const items = $$('.card', next);
    if (items.length) staggerIn(items); else anim(next, [{ opacity: 0 }, { opacity: 1 }], { duration: 250, easing: 'ease' });
  }));
}

function initIwt(el) {
  const tabs = $$('[role=tab]', el), media = $$('[data-panel-media]', el);
  let cur = 0;
  const panel = (t) => document.getElementById(t.getAttribute('aria-controls'));
  const go = async (n) => {
    const i = (n + tabs.length) % tabs.length;
    if (i === cur || !tabs.length) return;
    const old = panel(tabs[cur]), next = panel(tabs[i]);
    tabs.forEach((o, k) => { o.classList.toggle('is-on', k === i); o.setAttribute('aria-selected', k === i); });
    media.forEach((m, k) => m.classList.toggle('is-on', k === i));
    wipe(media[i], [...media[i].children], 600);
    cur = i;
    await anim(old, [{ opacity: 1 }, { opacity: 0 }], { duration: 200 })?.finished;
    old.hidden = true;
    next.hidden = false;
    anim(next, [{ opacity: 0 }, { opacity: 1 }], { duration: 300 });
  };
  tabs.forEach((t, i) => t.addEventListener('click', () => go(i)));
  el.addEventListener('animationend', (e) => { if (e.animationName === 'heroBar') go(cur + 1); });
}

// Revelar ao rolar: só o que ainda está fora da tela, para não atrasar o primeiro conteúdo
function initReveal(root) {
  if (REDUCE) return;
  const io = new IntersectionObserver((list) => list.forEach((e) => {
    if (!e.isIntersecting) return;
    io.unobserve(e.target);
    e.target._reveal();
  }), { rootMargin: '0px 0px -80px' });
  // A posição vem do observador, sem forçar layout. Só o que está abaixo da tela espera a animação
  const first = new IntersectionObserver((list) => list.forEach((e) => {
    first.unobserve(e.target);
    const sec = e.target, { hide, fn } = sec._first;
    if (e.boundingClientRect.top <= innerHeight) { if (sec.classList.contains('iwt')) sec.classList.add('is-in'); return; }
    hide.forEach((n) => n.classList.add('r-wait'));
    sec._reveal = fn;
    io.observe(sec);
  }));
  const add = (sec, hide, fn) => { sec._first = { hide, fn }; first.observe(sec); };
  $$('.fc, .bposts', root).forEach((s) => {
    const items = $$('.card, .bpost', s).filter((c) => !c.closest('[hidden]'));
    add(s, items, () => staggerIn(items));
  });
  $$('.clist', root).forEach((s) => {
    const cards = $$('.clist__i', s), imgs = cards.map((c) => c.querySelector('img')), txt = $$('.clist__h,.clist__c', s);
    add(s, [...imgs, ...txt], () => {
      [...imgs, ...txt].forEach((n) => n.classList.remove('r-wait'));
      cards.forEach((c, i) => {
        anim(c.querySelector('img'), [{ transform: 'scale(1.1)', opacity: 0 }, { transform: 'scale(1)', opacity: 1 }], { duration: 250, delay: i * 150, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'backwards' });
        [...c.querySelectorAll('.clist__h,.clist__c')].forEach((t, k) => anim(t, UP, { duration: 200, delay: i * 150 + k * 150, easing: 'cubic-bezier(.5,.06,.01,.99)', fill: 'backwards' }));
      });
    });
  });
  $$('.iwt', root).forEach((s) => {
    const m = s.querySelector('[data-panel-media].is-on'), c = s.querySelector('.iwt__c');
    add(s, [m, c].filter(Boolean), () => {
      m?.classList.remove('r-wait');
      c?.classList.remove('r-wait');
      s.classList.add('is-in');
      if (m) wipe(m, [...m.children], 600);
      anim(c, [{ opacity: 0 }, { opacity: 1 }], { duration: 300 });
    });
  });
}

// Segunda foto do card: só é baixada no primeiro hover
if (matchMedia('(hover:hover)').matches) document.addEventListener('pointerover', (e) => {
  const a = e.target.closest?.('.card__media[data-alt]');
  if (!a) return;
  const im = new Image();
  im.className = 'card__alt';
  im.alt = '';
  im.onload = () => requestAnimationFrame(() => im.classList.add('ok'));
  im.src = a.dataset.alt;
  a.append(im);
  a.removeAttribute('data-alt');
});

function initCarousel(el) {
  const rail = el.querySelector('[data-rail]');
  if (!rail) return;
  const step = () => rail.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0);
  const p = el.querySelector('[data-prev]'), n = el.querySelector('[data-next]'), bar = el.querySelector('[data-bar]');
  p?.addEventListener('click', () => rail.scrollBy({ left: -step() }));
  n?.addEventListener('click', () => rail.scrollBy({ left: step() }));
  const sync = () => {
    const max = rail.scrollWidth - rail.clientWidth;
    if (p) p.disabled = rail.scrollLeft < 2;
    if (n) n.disabled = rail.scrollLeft > max - 2;
    if (bar) {
      const w = (rail.clientWidth / rail.scrollWidth) * 100;
      bar.style.width = w + '%';
      bar.style.transform = `translateX(${max ? (rail.scrollLeft / max) * (100 / w - 1) * 100 : 0}%)`;
    }
  };
  rail.addEventListener('scroll', sync, { passive: true });
  afterLayout(rail, sync);
  if (matchMedia('(pointer:fine)').matches) {
    let down = false, x = 0, s = 0;
    rail.addEventListener('pointerdown', (e) => { down = true; x = e.clientX; s = rail.scrollLeft; rail.style.scrollSnapType = 'none'; });
    addEventListener('pointerup', () => { if (down) { down = false; rail.style.scrollSnapType = ''; } }, { passive: true });
    rail.addEventListener('pointermove', (e) => { if (down) rail.scrollLeft = s - (e.clientX - x); }, { passive: true });
    rail.addEventListener('dragstart', (e) => e.preventDefault());
  }
}

function initMarquee(el) {
  const t = el.querySelector('.cmn__track');
  if (!t || t.dataset.ready) return;
  t.dataset.ready = 1;
  [...t.children].forEach((c) => { const k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.tabIndex = -1; t.append(k); });
}

function initRecs(el) {
  new IntersectionObserver(async ([e], io) => {
    if (!e.isIntersecting) return;
    io.disconnect();
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs] .pgrid');
      if (next?.children.length >= 4) el.querySelector('.pgrid').replaceChildren(...next.children);
    } catch {}
  }, { rootMargin: '300px' }).observe(el);
}

function init(root = document) {
  $$('[data-ann]', root).forEach(initAnn);
  $$('[data-slideshow]', root).forEach(initSlideshow);
  $$('[data-tabs]', root).forEach(initTabs);
  $$('[data-carousel]', root).forEach(initCarousel);
  $$('[data-marquee]', root).forEach(initMarquee);
  $$('[data-recs]', root).forEach(initRecs);
  initReveal(root);
}
init();
// Editor de temas: reinicializa só a seção alterada
if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => e.target.querySelector('[data-ann]')?._stop?.());
}
